/** @jsxImportSource react */
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export const defaultOptions: ChartOptions = {
  responsive: true,
  aspectRatio: 3,
  plugins: {
    datalabels: {
      color: 'white',
      labels: {
        title: {
          align: 'bottom',
        },
      },
    },
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false, // Hide grid lines on the x-axis
      },
    },
    y: {
      border: {
        display: false,
      },
      position: 'right', // Display y-axis labels on the right-hand side
      ticks: {
        stepSize: 10,
      },
    },
  },
};

export default function BarChart({
  options = defaultOptions,
  data,
}: {
  options?: ChartOptions;
  data: any;
}) {
  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <Bar options={options} data={data} />
    </>
  );
}
